// Single source of truth for the version shown in the UI footer.
// Keep in step with the version field in package.json.
export const APP_VERSION = '2.9.2';
